function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowCircleRight = function SvgArrowCircleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 54159",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1878",
    cx: 25,
    cy: 25,
    r: 25,
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54060"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25840",
    d: "M2.293 27.256a2.155 2.155 0 0 0 1.323-.456l12.307-9.412a2.609 2.609 0 0 0 .045-4.028L4.014 3.744a2.184 2.184 0 0 0-3.209.515 2.624 2.624 0 0 0 .475 3.479l9.408 7.562-9.717 7.437A2.622 2.622 0 0 0 .42 26.2a2.243 2.243 0 0 0 1.874 1.054",
    transform: "translate(18.104 9.744)",
    style: {
      fill: "#80a9f7"
    }
  })));
};

export default SvgArrowCircleRight;